<ng-select
  [items]="items"
  [bindLabel]="bindLabel"
  [bindValue]="bindValue"
  [groupBy]="groupBy"
  [multiple]="multiple"
  [closeOnSelect]="false"
  [searchable]="searchable"
  [clearable]="clearable"
  [loading]="loading"
  [selectableGroup]="true"
  [selectableGroupAsModel]="false"
  [placeholder]="placeholder | translate"
  [ngModel]="value"
  (ngModelChange)="onValueChange($event)"
  (search)="onSearch($event)"
  (scrollToEnd)="scrollEnd.emit()"
  (clear)="onClear()"
  [disabled]="disabled">
  <!-- Grupo -->
  <ng-template ng-optgroup-tmp let-item="item" let-item$="item$">
    <div class="d-flex align-items-center gap-2 text-uppercase">
      <input
        aria-label="checkbox group"
        type="checkbox"
        class="form-check-input m-0"
        [checked]="item$.selected"
        tabindex="-1"
        readonly />

      <i *ngIf="getGroupIcon(item)" [class]="getGroupIcon(item)" aria-hidden="true"></i>

      <span class="f-14">
        {{ getGroupLabel(item) | translate }}
      </span>
    </div>
  </ng-template>

  <!-- Hijos -->
  <ng-template ng-option-tmp let-item="item" let-item$="item$">
    <div class="d-flex align-items-center gap-2 ms-4">
      <input
        aria-label="checkbox child"
        type="checkbox"
        class="form-check-input m-0"
        [checked]="item$.selected"
        tabindex="-1"
        readonly />

      <label class="form-check-label m-0">
        {{ item[bindLabel] }}
      </label>
    </div>
  </ng-template>

  <ng-template ng-loadingtext-tmp>
    <span class="mx-2">
      {{ loadingText | translate }}
    </span>
  </ng-template>

  <ng-template ng-notfound-tmp>
    <span class="mx-2">
      {{ notFoundText | translate }}
    </span>
  </ng-template>
</ng-select>
